module.exports = __webpack_public_path__ + "img/uluLogo.41276620.png";